module.exports = __webpack_public_path__ + "static/media/Photo Dr. Jacques El Khouri.5c9b2420.jpg";